import { VerifierBillingRulesFormFields, VerifierBillingRulesInputField } from './types';

export const verifierBillingRulesInputFieldsVariables: Array<VerifierBillingRulesInputField> = [
  {
    name: VerifierBillingRulesFormFields.verificationOfIncome,
    title: 'Verification of Income (VoI)',
    description: 'Amount paid for each Verification of Income Report (VoI)',
    label: 'Verification of Income',
  },
  {
    name: VerifierBillingRulesFormFields.verificationOfEmployment,
    title: 'Verification of Employment (VoE)',
    description: 'Amount paid for each Verification of Employment and Income Report (VoE)',
    label: 'Verification of Employment',
  },
  {
    name: VerifierBillingRulesFormFields.reverification,
    title: 'Reverification',
    description: 'Amount paid for each Reverification Report, for previously requested employees',
    label: 'Reverification',
  },
];
